// extracted by mini-css-extract-plugin
module.exports = {"fullWidthImg":"ImageFull-module--fullWidthImg--2sF_q","contentWidthImg":"ImageFull-module--contentWidthImg--3vPev","noPadding":"ImageFull-module--noPadding--2AY4R"};